import template from './icon.template.html';

// This will require all SVGs through webpack svg-sprite-loader
//let files = require.context('./svg', false, /\.svg$/);
//window.cuiIconNames = [];
//files.keys().forEach(function (name, index, arr) {
//    let strippedName = name.replace('.svg', '').replace('./', '');
//    window.cuiIconNames.push(strippedName);
//    files(name, index, arr);
//});

function component ($rootScope, $window) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            name: '@'
        },
        template,
        link
    };
    function link (scope, element) {
        // the webpack configuration prefixes svg names with 'cui'
        scope.iconHref = '/cldstatic/vdp/%%FINGERPRINT%%/spritemap.svg#' + scope.name;
        $rootScope.cuiIconNames = $window.cuiIconNames;
        element.addClass('cui-icon');
    }
}

component.$inject = ['$rootScope', '$window'];

export default component;
